import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "check-in-popup detail-popup" }
const _hoisted_2 = {
  key: 0,
  class: "loader-container flex-center"
}
const _hoisted_3 = {
  key: 2,
  class: "popup-content error-modal"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "An error occured while identifying the user. Please confirm you are logged in and try again.", -1 /* HOISTED */)
const _hoisted_5 = {
  key: 3,
  class: "popup-content error-modal"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "An error occurred while confirming the meeting. Please try confirming again later.", -1 /* HOISTED */)
const _hoisted_7 = { class: "error" }
const _hoisted_8 = {
  key: 4,
  class: "popup-content"
}
const _hoisted_9 = {
  key: 0,
  class: "check-in"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "check-in__heading flex-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "check-in__heading--title" }, "Check In"),
  /*#__PURE__*/_createElementVNode("div", { class: "check-in__heading--subheading" }, "We'd love to hear how it went!")
], -1 /* HOISTED */)
const _hoisted_11 = { class: "check-in__rating flex-center" }
const _hoisted_12 = { class: "check-in__feedback" }
const _hoisted_13 = {
  key: 1,
  class: "check-in"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "check-in__heading flex-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "check-in__heading--title" }, "Success!")
], -1 /* HOISTED */)
const _hoisted_15 = { class: "check-in__body flex-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "description" }, "Thank you for your feedback!", -1 /* HOISTED */)
const _hoisted_17 = {
  key: 0,
  class: "description"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("It looks like ")
const _hoisted_21 = { class: "name" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" hasn't confirmed the meeting just yet, but once they do you will see your Opt balance become available for withdrawal.")
const _hoisted_23 = {
  key: 5,
  class: "popup-content error-modal"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, "Based on our calendars, this scheduled meeting hasn't been held yet. Please try confirming again after the meeting has been held.", -1 /* HOISTED */)
const _hoisted_25 = {
  key: 6,
  class: "popup-content error-modal"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, "We were unable to access the meeting. Please try again later.", -1 /* HOISTED */)
const _hoisted_27 = {
  key: 7,
  class: "button-container horizontal"
}
const _hoisted_28 = {
  key: 8,
  class: "button-container horizontal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode($setup["Loader"])
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["CloseButton"], { onClickedClose: $setup.deepClosePopup }),
    ($setup.meetingMoment)
      ? (_openBlock(), _createBlock($setup["DetailsHeader"], {
          key: 1,
          meetingMoment: $setup.meetingMoment,
          name: $setup.otherUser?.name?.fullName
        }, null, 8 /* PROPS */, ["meetingMoment", "name"]))
      : _createCommentVNode("v-if", true),
    ($props.selectedMeeting && !$setup.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createCommentVNode("User is unknown"),
          _hoisted_4
        ]))
      : ($props.selectedMeeting && $setup.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createCommentVNode("An Error Occurred"),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, _toDisplayString($setup.error), 1 /* TEXT */)
          ]))
        : ($props.selectedMeeting && $setup.pastMeeting)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createCommentVNode("Confirm Meeting stuff goes here"),
              ($setup.stage == $setup.CheckInStage.FEEDBACK)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode($setup["StarRating"], {
                        grade: $setup.rating,
                        "onUpdate:grade": _cache[0] || (_cache[0] = ($event: any) => (($setup.rating) = $event))
                      }, null, 8 /* PROPS */, ["grade"])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode($setup["TextField"], {
                        label: "Feedback",
                        modelValue: $setup.feedback,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.feedback) = $event))
                      }, null, 8 /* PROPS */, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              ($setup.stage == $setup.CheckInStage.SUCCESS)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      (!$setup.isPayingUser)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            ($setup.Meetings.isMeetingConfirmed($props.selectedMeeting))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_18, " As soon as we're done processing the funds for this meeting, you will see your Opt balance become available for withdrawal."))
                              : ($props.selectedMeeting.status === $setup.Meetings.MeetingStatus.meetingEnded || $props.selectedMeeting.status === $setup.Meetings.MeetingStatus.collectorConfirmed )
                                ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                                    _hoisted_20,
                                    _createElementVNode("span", _hoisted_21, _toDisplayString($setup.otherUser.name.fullName), 1 /* TEXT */),
                                    _hoisted_22
                                  ]))
                                : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : ($props.selectedMeeting)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createCommentVNode("An Error Occurred"),
                _hoisted_24
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createCommentVNode("The Meeting Doesn't Exist"),
                _hoisted_26
              ])),
    ($setup.stage == $setup.CheckInStage.SUCCESS && $props.selectedMeeting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("button", {
            class: "borderless",
            onClick: $setup.deepClosePopup
          }, "Home")
        ]))
      : ($props.selectedMeeting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("button", {
              class: "borderless",
              onClick: $setup.closePopup
            }, "Back"),
            (!$setup.error && $setup.user && $setup.pastMeeting)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "primary",
                  onClick: $setup.confirmMeeting
                }, "Submit"))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
  ]))
}